var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#374DA0",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1752_25868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8448 5.66991C20.6704 5.67689 20.5022 5.70827 20.327 5.75186L8.47578 8.63925C7.07393 8.98274 6.19691 10.3968 6.54127 11.7995L8.20291 18.5838C8.3036 18.9879 8.49965 19.362 8.77465 19.6748C9.04964 19.9875 9.39557 20.2299 9.78347 20.3815V18.7468C9.78347 16.3433 11.7389 14.3879 14.1424 14.3879H25.1218L23.4872 7.65848C23.3426 7.07352 23.0008 6.55631 22.5193 6.19407C22.0377 5.83182 21.446 5.6467 20.8439 5.66991H20.8448ZM21.9067 9.42997L22.6154 12.3993L19.6731 13.1072L18.9373 10.1649L21.9067 9.42997ZM14.1424 16.1315C12.6988 16.1315 11.5271 17.3031 11.5271 18.7468V25.7212C11.5271 27.1649 12.6988 28.3366 14.1424 28.3366H26.3476C27.7913 28.3366 28.963 27.1649 28.963 25.7212V18.7468C28.963 17.3031 27.7913 16.1315 26.3476 16.1315H14.1424ZM14.1424 17.5211H26.3476C27.0197 17.5211 27.5733 18.0747 27.5733 18.7468V19.6186H12.9167V18.7468C12.9167 18.0747 13.4703 17.5211 14.1424 17.5211ZM12.9167 22.234H27.5733V25.7212C27.5733 26.3933 27.0197 26.9469 26.3476 26.9469H14.1424C13.8179 26.9451 13.5072 26.8154 13.2777 26.5859C13.0483 26.3564 12.9185 26.0457 12.9167 25.7212V22.234Z",
    fill: "#374DA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1752_25868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6667,
    height: 22.6667,
    fill: "white",
    transform: "translate(6.29633 5.66797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIcon);
export default __webpack_public_path__ + "static/media/ButtonIcon.c14e52bd757e29a0387253c9705f554d.svg";
export { ForwardRef as ReactComponent };